/**
 * YouTube API Initialization
 * Sets up window.YTReady promise and onYouTubePlayerAPIReady callback
 * This file must load before YouTube iframe API
 */
window.YTReady = new Promise((r) => {
  window.YTLoaded = function () {
    r();
  };
});
function onYouTubePlayerAPIReady() {
  window.YTLoaded();
}